<div class="px-3 timeline-simulator-container">
  @if (criteriaFormType === 'timeline-simulator-criteria-form2') {
    <timeline-simulator-criteria-form2 [(simulatorForm)]="simulatorForm" (simulate)="simulate()">
    </timeline-simulator-criteria-form2>
  }

  <div class="pt-3 mt-2 preview-container">
    <header class="d-flex flex-column flex-md-row align-items-center justify-content-md-between">
      <div class="d-flex align-items-center left-header">
        <div class="d-flex display-switches">
          <button
            type="button"
            class="btn"
            [class.active]="timelineDisplayMode === TimelineDisplayMode.VerticalList"
            (click)="changeTimelineDisplay(TimelineDisplayMode.VerticalList)">
            <img
              alt="Vertical List timeline"
              [ngSrc]="
                timelineDisplayMode === TimelineDisplayMode.VerticalList
                  ? '/assets/img/project-v2/timeline/vertical-list-active.svg'
                  : '/assets/img/project-v2/timeline/vertical-list-timeline.svg'
              "
              width="16"
              height="12" />
          </button>
          <button
            type="button"
            class="btn"
            [class.active]="timelineDisplayMode === TimelineDisplayMode.HorizontalMultiLine"
            (click)="changeTimelineDisplay(TimelineDisplayMode.HorizontalMultiLine)">
            <img
              alt="Horizontal Multi-line timeline"
              [ngSrc]="
                timelineDisplayMode === TimelineDisplayMode.HorizontalMultiLine
                  ? '/assets/img/project-v2/timeline/horizontal-multiline-active.svg'
                  : '/assets/img/project-v2/timeline/horizontal-multiline-timeline.svg'
              "
              width="16"
              height="12" />
          </button>
        </div>
        <h2 class="mb-0">{{ 'timelineSimulator_plannersPreview' | translate }}</h2>
      </div>

      <div class="d-flex flex-column flex-md-row simulator-buttons">
        <button
          type="button"
          class="btn text-uppercase btn-simulate"
          (click)="performSimulation()"
          [disabled]="simulatorForm?.invalid"
          >{{ 'timelineSimulator_simulateNow' | translate }}</button
        >
        <button
          type="button"
          class="btn text-uppercase btn-print"
          (click)="downloadTimeline()"
          [disabled]="simulatorForm?.invalid"
          >{{ 'timelineSimulator_printTimeline' | translate }}</button
        >
      </div>
    </header>

    @if (timelineToDisplay.length > 0 && !isLoading) {
      <div class="mt-3 preview-inner-container">
        @if (timelineDisplayMode === TimelineDisplayMode.VerticalList) {
          <mtm-vertical-list-timeline
            [timeline]="timelineToDisplay"
            [canEdit]="false"
            [isHeaderVisible]="true"
            [expandable]="false"
            [isCenterAlign]="false"
            [compact]="false"
            [isMilestoneColumnStretch]="false"
            [hasBorder]="true"></mtm-vertical-list-timeline>
        }
        @if (timelineDisplayMode === TimelineDisplayMode.HorizontalMultiLine) {
          <mtm-horizontal-multiline-timeline [timeline]="timelineToDisplay" [canEdit]="false">
          </mtm-horizontal-multiline-timeline>
        }
      </div>
    }

    @if (isLoading) {
      <div class="my-3 loading-container">
        <span class="d-flex flex-column align-items-center">
          <span class="me-2">{{ 'loading' | translate }}</span>
          <mtm-loading-spinner [size]="18"></mtm-loading-spinner>
        </span>
      </div>
    }
  </div>

  <footer>
    <div class="d-flex buttons align-items-center footer-buttons my-4">
      @if (timeline.length > 0) {
        <button type="button" class="btn btn-back text-uppercase" (click)="goBack()">
          <span>{{ 'back' | translate }}</span>
        </button>
      }
    </div>
  </footer>
</div>
